var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { ScrollBar } from '@/shared-components/mixin/scroll-v2/Scroll';
import styled from 'styled-components';
var GridItemBase = styled(ScrollBar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    ", "\n    position: relative;\n"], ["\n    ", "\n    ", "\n    ", "\n    ", "\n    position: relative;\n"])), function (_a) {
    var row = _a.row;
    return row && "grid-row: ".concat(row, ";");
}, function (_a) {
    var column = _a.column;
    return column && "grid-column: ".concat(column, ";");
}, function (_a) {
    var area = _a.area;
    return area && "grid-area: ".concat(area, ";");
}, function (_a) {
    var overflow = _a.overflow;
    return overflow && "overflow: ".concat(overflow, ";");
});
export var GridItemFlex = styled(GridItemBase)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n    ", "\n    ", "\n    ", "\n"], ["\n    display: flex;\n    position: relative;\n    ", "\n    ", "\n    ", "\n"])), function (_a) {
    var gap = _a.gap;
    return gap && "gap: ".concat(gap, ";");
}, function (_a) {
    var justify = _a.justify;
    return justify && "justify-content: ".concat(justify, ";");
}, function (_a) {
    var align = _a.align;
    return align && " align-items: ".concat(align, ";");
});
/**
 * @example
 * // Basic GridItem with row and column definition
 * <GridItem row="1" column="2">
 *     <div>Content</div>
 * </GridItem>
 *
 * // GridItem with Flex layout and custom gap, justify, and align
 * <GridItem.Flex gap="10px" justify="center" align="stretch">
 *     <div>Content</div>
 * </GridItem.Flex>
 */
var GridItem = Object.assign(GridItemBase, {
    Flex: GridItemFlex,
});
export { GridItem };
var templateObject_1, templateObject_2;
